// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"f5213efb","66":"f5213efb","71":"bc534f22","271":"b143e8bf","540":"f5213efb","603":"f5213efb","634":"f5213efb","740":"6d6d4bdc","751":"f5213efb","781":"f5213efb","851":"f5213efb","895":"f5213efb"}[chunkId] + ".chunk.css";
};